module.exports = __webpack_public_path__ + "24e004ab/img/share-icon.0f8a11b4.svg";